export default class FormValidate {
    constructor () {
        this.form = document.querySelector('[data-form-validate]')

        if (!this.form)
            return

        this.status = this.form
            && this.form.querySelector('.form-status')

        this.requiredFields = Array.from(this.form
            .querySelectorAll('input, textarea, select'))
            .filter(el => el.hasAttribute('required'))

        this.form
            .addEventListener('submit', this.submit.bind(this))
    }

    fieldValidity (el) {
        const field = el.closest('.form-field')

        if (!field)
            return

        field.classList[el.checkValidity()
            ? 'remove'
            : 'add']('form-field-invalid')
    }

    watchChanges (el) {
        let timer = 0

        el.addEventListener('keyup', (e) => {
            clearTimeout(timer)

            timer = setTimeout(() => {
                if (!e.target.value.length) {
                    this.status.removeAttribute('data-form-validity')
                    this.status.innerHTML = ''
                }
            }, 500)
        })
    }

    statusMsg (success) {
        const { msgError, msgSuccess } = this.status.dataset

        this.status.setAttribute('data-form-validity', success)

        this.status
            .innerHTML = success
                ? msgSuccess
                : msgError
    }

    async submit (e) {
        e.preventDefault()
        e.stopPropagation()

        const isInvalid = this.requiredFields.filter(el => !el.validity.valid)

        if (isInvalid?.length > 0)
            return

        this.requiredFields.forEach(el => {
            this.watchChanges(el)
        })

        const body = []

        const data = new window.FormData(this.form)

        for (const key of data.keys())
            if (data.get(key))
                body.push(`${
                    encodeURIComponent(key)}=${
                    encodeURIComponent(data.get(key))}`)

        try {
            const request = await window
                .fetch(this.form.action, {
                    method: this.form.method,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: body.join('&')
                })

            // If request isn't successful, throw error
            if (!request.ok)
                throw new Error()

            // If request is successful, return success message
            const data = await request.json()
            this.statusMsg(1)
            return data
        }
        catch (err) {
            // If request is successful, return error message
            this.statusMsg(1)
        }
    }
}
